import { render, staticRenderFns } from "./Inventarios.vue?vue&type=template&id=1f90d30a"
import script from "./Inventarios.vue?vue&type=script&lang=js"
export * from "./Inventarios.vue?vue&type=script&lang=js"
import style0 from "./Inventarios.vue?vue&type=style&index=0&id=1f90d30a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports